define('taoQtiItem/qtiCreator/model/choices/Hottext',[
    'lodash', 
    'taoQtiItem/qtiCreator/model/mixin/editable', 
    'taoQtiItem/qtiItem/core/choices/Hottext'
], function(_, editable, Choice){
    "use strict";
    var methods = {};
    _.extend(methods, editable);
    _.extend(methods, {
        getDefaultAttributes : function(){
            return {
               fixed : false
            };
        }
    });
    return Choice.extend(methods);
});
